import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=054aa2a5&scoped=true&"
import script from "./Checkbox.vue?vue&type=script&lang=ts&"
export * from "./Checkbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054aa2a5",
  null
  
)

export default component.exports